import request from '@/utils/request'

let CserviceApi = {


  userlist(data) {
        return request._post('/shop/plus.cservice.Index/index', data);
    },

  /*删除货运公司*/
      deleteuser(data) {
        return request._post('/shop/user.user/delete', data);
  },


/*添加货运公司*/
add(data) {
    return request._post('/shop/plus.cservice.Index/add', data);
},
/*修改货运公司*/
edit(data) {
    return request._post('/shop/plus.cservice.Index/edit', data);
},
/*删除货运公司*/
del(data) {
    return request._post('/shop/plus.cservice.Index/del', data);
},
/*货运公司详情*/
detail(data) {
  return request._post('/shop/plus.cservice.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.cservice.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.cservice.Setting/getSetting', data, errorback);
    },
}
export default CserviceApi;



// WEBPACK FOOTER //
// ./src/api/cservice.js